<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-24">
            <h1>iPad Enrollment History</h1>
        </div>
    </div>
    <fieldset>
        <legend>Search for an iPad Enrollment</legend>
        <div class="row">
            <div class="col-6">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Beneficiary Name'"
                                        id="BeneficiaryName"
                                        [text]="memberService.BeneficiaryName"
                                        (onValueChange)="memberService.BeneficiaryName = $event">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-6">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Beneficiary Email'"
                                        id="BeneficiaryEmail"
                                        [text]="memberService.BeneficiaryEmail"
                                        (onValueChange)="memberService.BeneficiaryEmail = $event">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-6">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Agent ID'"
                                        id="AgentId"
                                        [text]="memberService.AgentId"
                                        (onValueChange)="memberService.AgentId = $event">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="input-wrapper">
                    <label for="dateAppointment">Application Start Date</label>
                    <JQDatePicker [selectedDate]="memberService.ApplicationStartDate" (elementClicked)="memberService.ApplicationStartDate = $event"></JQDatePicker>
                </div>
            </div>
            <div class="col-6">
                <div class="input-wrapper">
                    <label for="dateAppointment">Application End Date</label>
                    <JQDatePicker [selectedDate]="memberService.ApplicationEndDate" (elementClicked)="memberService.ApplicationEndDate = $event"></JQDatePicker>
                </div>
            </div>
        </div>
    </fieldset>
    <div class="row">
        <div class="col-24">
            <button type="button" class="button primary" (click)="iSearch()">Search</button>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <div class="bottom-10">
                <button id="exportToExcel" class="button link excel" (click)="exportToExcel()">Export to Excel</button>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24"> 
            <jqxGrid [width]="gridwidth" 
                     [height]="gridheight"
                     [virtualmode]="true"
                     [rendergridrows]="rendergridrows" 
                     [source]="dataAdapter" 
                     [columns]="columns" 
                     [enablebrowserselection]="true" 
                     [autoshowcolumnsmenubutton]="false" 
                     [handlekeyboardnavigation]="true"
                     [columnsresize]="true"
                     [selectionmode]="'multiplecellsadvanced'"
                     [pageable]="true" 
                     [pagesizeoptions]="[20, 50, 100]" 
                     [pagesize]="50" 
                     [sortable]="true" 
                     [filterable]="true" 
                     [ready]="ready"
                     [editable]="false"
                      [columnsresize]="true"
                     [updatefilterconditions]="updatefilterconditions"
                     (onSort)="onSort($event)"
                     (onFilter)="onFilter($event)"
                     (onPagesizechanged)="onPageSizeChanged($event)"
                     (onCellclick)="Cellclick($event)" 
                     #gridReference>
            </jqxGrid>
        </div>
    </div>
</div>
